<template>
  <div id="page">
    <c-client-type v-if="clientType === null" v-model:client-type="clientType"
                   v-model:title="title"/>

    <c-private-appointment v-if="clientType === 0" @back="this.clientType = null"/>
    <c-professional-appointment v-if="clientType === 1" @back="this.clientType = null"/>
  </div>
</template>

<script>
import '../assets/tailwind.css';
import ChooseClientType from '@/components/ChooseClientType';
import AppointmentAsPrivate from '@/components/AppointmentAsPrivate';
import AppointmentAsProfessional from '@/components/AppointmentAsProfessional';

export default {
  name: 'Home',

  components: {
    'c-client-type': ChooseClientType,
    'c-private-appointment': AppointmentAsPrivate,
    'c-professional-appointment': AppointmentAsProfessional,
  },

  data() {
    return {
      language: 'nl',
      clientType: null,
      title: false,
    };
  },

  watch: {
    language() {
      this.$root.$i18n.locale = this.language;
    }
  },
};
</script>

<style scoped>
body {
  background-color: red;
}

#page {
  width: 830px;
  @apply mx-auto;
}

@media only screen and (max-width: 800px) {
  body {
    background-color: orange;
  }

  #page {
    width: 100%;
    @apply mx-auto;
  }
}
</style>
